import api from './api';

const accountingService = {
  // Accounts
  getAccounts: (includeInactive = false) => api.get(`/accounts?includeInactive=${includeInactive}`),
  getAccount: (id: number) => api.get(`/accounts/${id}`),
  createAccount: (data: any) => api.post('/accounts', data),
  updateAccount: (id: number, data: any) => api.put(`/accounts/${id}`, data),
  deleteAccount: (id: number) => api.delete(`/accounts/${id}`),

  // Journal Entries
  getJournalEntries: (status?: string) => api.get(`/journalentries${status ? `?status=${status}` : ''}`),
  getJournalEntry: (id: number) => api.get(`/journalentries/${id}`),
  createJournalEntry: (data: any) => api.post('/journalentries', data),
  postJournalEntry: (id: number) => api.post(`/journalentries/${id}/post`),
  voidJournalEntry: (id: number) => api.post(`/journalentries/${id}/void`),

  // Reports
  getTrialBalance: () => api.get('/accounts/trial-balance'),
  getBalanceSheet: () => api.get('/accounts/balance-sheet'),
  getIncomeStatement: () => api.get('/accounts/income-statement'),
};

export default accountingService;
